type PictureProps = {
    path: string;
    alt?: string;
    className?: string;
};

export default function Picture({ path, alt, className = '' }: PictureProps) {
    return (
        <picture>
            <source type='image/webp' srcSet={`/img/${path}.webp`} />
            <img src={`/img/${path}.jpg`} alt={alt} className={className} />
        </picture>
    );
}
